import {
  CONTENT_TYPES,
  isKnowledgeBaseGame,
  isTrainerGame,
} from "./contentType";

export function scenarioNodeHasVideo(node) {
  if (!node?.data) return false;
  return (
    node.data.video === "X" &&
    typeof node.data.videopath === "string" &&
    node.data.videopath.trim() !== ""
  );
}

export function hasAnyScenarioVideo(game) {
  return (game?.nodes ?? []).some(scenarioNodeHasVideo);
}

export function findScenarioVideoNodeForScene(game, scene) {
  const nodes = game?.nodes ?? [];
  const edges = game?.edges ?? [];
  const sceneKey = String(scene);

  if (sceneKey === "1") {
    const startNode = nodes.find((node) => String(node.id) === "1");
    return scenarioNodeHasVideo(startNode) ? startNode : null;
  }

  const directNode = nodes.find((node) => String(node.id) === sceneKey);
  if (scenarioNodeHasVideo(directNode)) {
    return directNode;
  }

  const edge = edges.find((item) => item.source === sceneKey);
  if (!edge) return null;

  const targetNode = nodes.find((node) => node.id === edge.target);
  return scenarioNodeHasVideo(targetNode) ? targetNode : null;
}

export function getTelegramPreviewPlan(game, scene = 1) {
  if (isTrainerGame(game)) {
    const hasQuestions = (game?.trainerQuestions ?? []).some((item) =>
      item?.questionText?.trim()
    );
    if (!hasQuestions && !game?.trainerTheme?.trim()) {
      return {
        mode: "message",
        type: "help",
        message:
          "В тренажёре пока нет вопросов. Добавьте хотя бы один вопрос и нажмите «Запустить» снова.",
      };
    }
    return { mode: "local", contentType: CONTENT_TYPES.trainer };
  }

  if (isKnowledgeBaseGame(game)) {
    const items = (game?.kbItems ?? []).filter(
      (item) => item?.question?.trim() || item?.answerText?.trim() || item?.hasVideo
    );
    if (!items.length) {
      return {
        mode: "message",
        type: "help",
        message:
          "В базе знаний пока нет вопросов. Добавьте пары «вопрос — ответ» и попробуйте снова.",
      };
    }
    return { mode: "local", contentType: CONTENT_TYPES.knowledge_base };
  }

  if (!hasAnyScenarioVideo(game)) {
    return {
      mode: "message",
      type: "help",
      message:
        "В сценарии пока нет сцен с видео. Загрузите видео в сцену и нажмите «Запустить» снова.",
    };
  }

  const videoNode = findScenarioVideoNodeForScene(game, scene);
  if (!videoNode) {
    return {
      mode: "message",
      type: "help",
      message: "Для этой сцены видео не загружено.",
    };
  }

  return { mode: "socket", scene: videoNode.id === "1" ? 1 : scene };
}
